/**
 * Reef Telecom quote / PO buttons.
 *
 * One delegated handler for every [data-reef-quote] button (PDP $0 products,
 * PDP priced products, cart drawer, cart page). The ERP widget that defines
 * window.ReefChat is loaded late and may be blocked by corporate proxies, so
 * every path has a hard fallback to the portal and never throws at the user.
 *
 * Modes (data-reef-quote):
 *   "product" - ReefChat.requestQuote(payload) built from the button's data-* attributes
 *   "cart"    - ReefChat.addToPortalQuote()
 */
(function () {
  // Theme setting "Customer portal URL" (Reef Telecom group), exposed by layout/theme.liquid.
  var portalBase = (window.ReefSettings && window.ReefSettings.portalUrl) || 'https://portal.reeftel.com/';
  var PORTAL = portalBase.replace(/\/?$/, '/') + '?view=quote';
  var RESET_MS = 8000;
  var SPINNER =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="reef-spin" aria-hidden="true" focusable="false"><path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4m-3.93 7.07l-2.83-2.83M6.34 6.34L3.51 3.51"/></svg> ';

  function status(btn, text) {
    var region = btn.parentElement && btn.parentElement.querySelector('[data-reef-quote-status]');
    if (!region) {
      region = document.createElement('span');
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('data-reef-quote-status', '');
      btn.insertAdjacentElement('afterend', region);
    }
    region.textContent = text;
  }

  function busy(btn) {
    btn.__reefOriginal = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = SPINNER + 'Transferring\u2026';
    status(btn, 'Transferring to the Reef quote portal\u2026');
    btn.__reefReset = window.setTimeout(function () { idle(btn); }, RESET_MS);
  }

  function idle(btn) {
    window.clearTimeout(btn.__reefReset);
    btn.removeAttribute('aria-busy');
    if (btn.__reefOriginal != null) btn.innerHTML = btn.__reefOriginal;
    status(btn, '');
  }

  function go(btn, url) {
    window.clearTimeout(btn.__reefReset);
    window.location.href = url;
  }

  function productPayload(d) {
    return {
      sku: d.sku || '',
      title: d.title || '',
      variantId: d.variantId || '',
      price: Number(d.price) || 0,
      compareAtPrice: Number(d.compareAtPrice) || 0,
      currency: d.currency || 'USD',
      productUrl: d.productUrl || '',
      available: d.available === 'true',
      source: d.source || 'shopify-pdp'
    };
  }

  function productFallback(p) {
    return PORTAL + '&requestQuote=1' +
      '&sku=' + encodeURIComponent(p.sku) +
      '&title=' + encodeURIComponent(p.title) +
      '&variantId=' + encodeURIComponent(p.variantId) +
      '&price=' + encodeURIComponent(p.price) +
      '&compareAtPrice=' + encodeURIComponent(p.compareAtPrice) +
      '&currency=' + encodeURIComponent(p.currency) +
      '&productUrl=' + encodeURIComponent(p.productUrl) +
      '&available=' + encodeURIComponent(p.available) +
      '&source=' + encodeURIComponent(p.source);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-reef-quote]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var chat = window.ReefChat;
    busy(btn);

    if (btn.dataset.reefQuote === 'cart') {
      var cartFallback = PORTAL + '&fromShopify=1';
      if (chat && typeof chat.addToPortalQuote === 'function') {
        try {
          Promise.resolve(chat.addToPortalQuote()).catch(function () { go(btn, cartFallback); });
        } catch (e) {
          go(btn, cartFallback);
        }
      } else {
        go(btn, cartFallback);
      }
      return;
    }

    var payload = productPayload(btn.dataset);
    var fallback = productFallback(payload);
    try { console.debug('[ReefChat] Request Quote payload', payload); } catch (e) {}
    if (chat && typeof chat.requestQuote === 'function') {
      try {
        chat.requestQuote(payload);
      } catch (e) {
        go(btn, fallback);
      }
    } else {
      go(btn, fallback);
    }
  });
})();
